import { Button as Button, Dropdown as Dropdown, ScrollSpy as ScrollSpy, Tab as Tab, Collapse as Collapse } from 'bootstrap';
import '@fortawesome/fontawesome-free/css/all.css';
import Swiper, { Autoplay, Navigation, Pagination, EffectFade } from "swiper";
Swiper.use([Autoplay, Navigation, Pagination, EffectFade]);
import "swiper/swiper-bundle.css";
import AOS from "aos";
import "aos/dist/aos.css";

import Rellax from "rellax";

import './styles.scss';
import { auto } from '@popperjs/core';


document.addEventListener("DOMContentLoaded", function () {
  window.addEventListener("scroll", function () {
    if (window.scrollY > 150) {
      document.getElementById("header").classList.add("scrolled");
      document.getElementById("header").classList.remove("closed");
    } else {
      document.getElementById("header").classList.remove("scrolled");
      document.getElementById("header").classList.remove("closed");
    }
  });
});

$( document ).ready( function() {

  AOS.init({
    offset: 120, // offset (in px) from the original trigger point
    delay: 0, // values from 0 to 3000, with step 50ms
    duration: 1000, // values from 0 to 3000, with step 50ms
    easing: "ease", // default easing for AOS animations
    once: true, // whether animation should happen only once - while scrolling down
  });

  $(".burger .burger-button").on("click touch", function (e) {
    e.preventDefault();
    if ($("header").hasClass("open")) {
      $("header").addClass("closed");
    } else {
      $("header").removeClass("closed");
    }
    $("header").toggleClass("open");
    
    $(".burger .burger-button").toggleClass("active");
    $(".header-right").toggleClass("active");
  });

  $(".close-button").on("click touch", function (e) {
    e.preventDefault();
    $("header").removeClass("open");
    $(".burger .burger-button").removeClass("active");
    $(".header-right").removeClass("active");
  });

  if(window.location.hash) {
    var target = window.location.hash;
    $("html, body").animate({ scrollTop: $(target).offset().top - 85 }, 0);
  }

  $(function () {
    $('.current-menu-item a[href*="#"]:not([href="#"])').click(function () {
      if (
        location.pathname.replace(/^\//, "") ==
          this.pathname.replace(/^\//, "") &&
        location.hostname == this.hostname
      ) {
        var target = $(this.hash);
        target = target.length
          ? target
          : $("[name=" + this.hash.slice(1) + "]");
        if (target.length) {

          $("html, body").animate(
            { scrollTop: $(target).offset().top - 85 },
            0
          );
          return false;
        }
      }
    });
  });

  $('.anchor').on('click touch', function (e) {
    e.preventDefault();
    var target = $(this).attr( 'href' );
    if ($(target).length > 0) {
      $("html, body").animate({ scrollTop: $(target).offset().top - 85 }, 0);
      return false;
    } else {
      $("html, body").animate({ scrollTop: $("#footer").offset().top - 85 }, 0);
      return false;
    }
  });


  if ($("#counter-box").length > 0) {
    var a = 0;
    counterFunction();
    $(window).scroll(function () {
      counterFunction();
    });
  }

  function counterFunction() {
    var oTop = $("#counter-box").offset().top - window.innerHeight;
    if (a == 0 && $(window).scrollTop() > oTop) {
      setTimeout( function() {
        $(".counter").each(function () {
          var $this = $(this),
            countTo = $this.attr("data-number");
          $({
            countNum: $this.text(),
          }).animate(
            {
              countNum: countTo,
            },

            {
              duration: 2000,
              easing: "swing",
              step: function () {
                //$this.text(Math.ceil(this.countNum));
                $this.text(Math.ceil(this.countNum).toLocaleString("en"));
              },
              complete: function () {
                $this.text(Math.ceil(this.countNum).toLocaleString("en"));
                //alert('finished');
              },
            }
          );
        });
      }, 500);
      a = 1;
    }
  }

  if ($(".landing_page_block").length > 0 ) {
    setTimeout(function () {
      $(".landing_page_block").addClass("animating");
    }, 1000);
    setTimeout(function () {
      $(".landing_page_block").addClass("step-1");
    }, 1200);
    setTimeout(function () {
      $(".landing_page_block").addClass("step-2");
    }, 2500);
    setTimeout(function () {
      $(".landing_page_block").addClass("step-3");
      $("html, body").addClass("ready");
    }, 3000);
    setTimeout(function () {
      $(".landing_page_block").addClass("step-4");
    }, 4600);
  }


  var full_page_swiper = new Swiper(".full_size_slider_block .swiper", {
    loop: true,
    autoHeight: true,
    pagination: {
      el: ".full_size_slider_block .swiper-pagination",
      type: "bullets",
    },
    navigation: {
      nextEl: ".full_size_slider_block .swiper-button-next",
      prevEl: ".full_size_slider_block .swiper-button-prev",
    },
    autoplay: {
      delay: 4500,
      disableOnInteraction: false,
      pauseOnMouseEnter: false,
    },
    speed: 1000,
    slidesPerView: 1,
    spaceBetween: 0,
    breakpoints: {
      768: {
        slidesPerView: auto,
        slidesPerGroupAuto: true
      },
    },
  });

  var floor_plan_swiper = new Swiper(".floor_plan_block .swiper", {
    loop: true,
    autoHeight: true,
    navigation: {
      nextEl: ".floor_plan_block .swiper-button-next",
      prevEl: ".floor_plan_block .swiper-button-prev",
    },
    autoplay: {
      delay: 7500,
      disableOnInteraction: false,
      pauseOnMouseEnter: false,
    },
    speed: 1000,
    slidesPerView: 1,
    spaceBetween: 0,
  });

  var slider_swiper = new Swiper(".slider_block .swiper", {
    loop: true,
    autoHeight: false,
    navigation: {
      nextEl: ".slider_block .swiper-button-next",
      prevEl: ".slider_block .swiper-button-prev",
    },
    autoplay: {
      delay: 4500,
      disableOnInteraction: false,
      pauseOnMouseEnter: false,
    },
    speed: 1000,
    slidesPerView: 1,
    spaceBetween: 15,
    breakpoints: {
      768: {
        slidesPerView: auto,
      },
    },
  });

});

window.onload = function () {
  var rellax = new Rellax(".rellax", {
    center: true,
  });
};